import React from "react";
import "./Projects.css";
import { FiExternalLink, FiGithub } from "react-icons/fi";

const ProjectSite = ({ Des, ProjectLink, GithubLink, image, tags }) => {
  return (
    <div className="project-site glass-panel">
      <div className="project-image-wrapper">
        <img src={image} alt="project-screenshot" className="project-image" />
        <div className="project-overlay">
          <div className="project-links-hover">
             {ProjectLink && (
              <a href={ProjectLink} target="_blank" rel="noreferrer" className="icon-link">
                <FiExternalLink size={24} />
              </a>
            )}
            {GithubLink && (
              <a href={GithubLink} target="_blank" rel="noreferrer" className="icon-link">
                <FiGithub size={24} />
              </a>
            )}
          </div>
        </div>
      </div>
      
      <div className="project-info">
        <p className="project-description">{Des}</p>
        {tags && (
          <div className="project-tags">
            {tags.map((tag, index) => (
              <span key={index} className="tag">{tag}</span>
            ))}
          </div>
        )}
        <div className="project-action-links">
           <a href={ProjectLink} target="_blank" rel="noreferrer" className="text-link">Live Preview</a>
           <span className="separator">•</span>
           <a href={GithubLink} target="_blank" rel="noreferrer" className="text-link">Source Code</a>
        </div>
      </div>
    </div>
  );
};

export default ProjectSite;
